"use client";

import { c as _c } from "react/compiler-runtime";
import type { ThemeProviderProps } from "next-themes";
import { useEffect, useState } from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
export function ThemeProvider(t0) {
  const $ = _c(10);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!mounted) {
    let t3;
    if ($[5] !== children) {
      t3 = <>{children}</>;
      $[5] = children;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== children || $[8] !== props) {
    t3 = <NextThemesProvider {...props} defaultTheme="system" enableSystem={true} attribute="class">{children}</NextThemesProvider>;
    $[7] = children;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}